var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Check"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.5 48.1815L20.25 36.9293L23.4293 33.75L31.5 41.8185L48.5662 24.75L51.75 27.9337L31.5 48.1815Z",
    fill: "#0059B3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M36 4.5C29.7699 4.5 23.6797 6.34744 18.4996 9.80871C13.3194 13.27 9.28197 18.1896 6.89781 23.9455C4.51365 29.7013 3.88984 36.0349 5.10528 42.1453C6.32071 48.2557 9.3208 53.8685 13.7261 58.2739C18.1315 62.6792 23.7443 65.6793 29.8547 66.8947C35.9651 68.1102 42.2987 67.4864 48.0545 65.1022C53.8104 62.718 58.73 58.6806 62.1913 53.5005C65.6526 48.3203 67.5 42.2301 67.5 36C67.5 27.6457 64.1813 19.6335 58.2739 13.7261C52.3665 7.81874 44.3543 4.5 36 4.5ZM36 63C30.6599 63 25.4397 61.4165 20.9996 58.4497C16.5595 55.4829 13.0988 51.2661 11.0553 46.3325C9.0117 41.3988 8.47701 35.97 9.51881 30.7326C10.5606 25.4951 13.1321 20.6841 16.9081 16.9081C20.6841 13.1321 25.4951 10.5606 30.7326 9.5188C35.9701 8.477 41.3989 9.01169 46.3325 11.0553C51.2661 13.0988 55.4829 16.5595 58.4497 20.9996C61.4165 25.4397 63 30.6599 63 36C63 43.1608 60.1554 50.0284 55.0919 55.0919C50.0284 60.1554 43.1609 63 36 63Z",
    fill: "#0059B3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.62d87aeaec4c475c2dbe4b1962a7d820.svg";
export { ForwardRef as ReactComponent };